import { component } from 'picoapp';
import './Collection.scss';

class Collection {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.el = el;
    // this.init();
  }

  init() {
    // console.log('product view');
  }
}

export default component((node, ctx) => {
  new Collection(node, ctx);
});
